module.exports = __webpack_public_path__ + "static/img/thoracicPain_0.f017f08f.png";